<app-header [layout]="layout"></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
